<template>
	<c-dialog ref="dialog" title="任务详情" mode="slide" width="100vw-300" enable-flex mask-close :button="false">
		<template #head>
			<div v-if="detailData.process_code" class="m-detail-tag flex-center-cross">
				<label>{{detailData.process_code}}</label>
				<c-state dict="orderStateDic" tag :value="detailData.state"></c-state>
				<c-state dict="priorityDic" tag :value="detailData.priority"></c-state>
				<c-state type="expectedDate" tag :value="detailData.expected_date"></c-state>
			</div>
		</template>
		
		<module>
			<module-col size="350">
				<c-detail class="m-detail-form">
					<c-detail-item label="任务二维码">
						<c-qrcode :value="detailData.h5_web" size="100"></c-qrcode>
					</c-detail-item>
					<c-detail-item label="产品编号">
						{{detailData.product_code}}
					</c-detail-item>
					<c-detail-item label="产品名称">
						{{detailData.product_name}}
						<span v-if="detailData.product_spec"> [{{detailData.product_spec}}]</span>
					</c-detail-item>
					<c-detail-item label="加工类型">
						<c-state dict="processTypeDic" :value="detailData.process_type"></c-state>
					</c-detail-item>
					<c-detail-item label="工序名称">
						{{detailData.process_name}}
					</c-detail-item>
					<c-detail-item label="检验方式">
						<c-state dict="testModeDic" :value="detailData.test_mode"></c-state>
					</c-detail-item>
					<c-detail-item label="任务进度">
						<c-progress :rate="[detailData.fine_count, detailData.plan_count]" :color="((detailData.fine_count/detailData.plan_count)>=1||detailData.plan_count==0) ?'green':'blue'"></c-progress>
					</c-detail-item>
					<c-detail-item label="报工数配比">
						{{detailData.output_ratio}}
					</c-detail-item>
					<c-detail-item label="计划数">
						{{detailData.plan_count}}
					</c-detail-item>
					<c-detail-item label="良品数">
						{{detailData.fine_count}}
					</c-detail-item>
					<c-detail-item label="不良品数">
						{{detailData.defects_count}}
					</c-detail-item>
					<c-detail-item label="已外发数">
						{{detailData.out_sourcing_plan_count}}
					</c-detail-item>
					<c-detail-item label="计划开始时间">
						{{detailData.plan_start_date}}
					</c-detail-item>
					<c-detail-item label="计划结束时间">
						{{detailData.plan_end_date}}
					</c-detail-item>
					<c-detail-item label="物料自动出库">
						<c-state dict="openCloseDic" :value="detailData.material_auto_out"></c-state>
					</c-detail-item>
					<c-detail-item label="成品自动入库">
						<c-state dict="openCloseDic" :value="detailData.product_auto_in"></c-state>
					</c-detail-item>
					<c-detail-item label="实际开始时间">
						{{detailData.real_start_date}}
					</c-detail-item>
					<c-detail-item label="实际结束时间">
						{{detailData.real_end_date}}
					</c-detail-item>
					<c-detail-item label="创建人">
						{{detailData.create_user_realname}}
					</c-detail-item>
					<c-detail-item label="创建时间">
						{{detailData.create_date}}
					</c-detail-item>
					<c-detail-item label="关联工单">
						<c-link v-if="auth('m_work')" @click="globalDialog('workDetail', {props: {id: detailData.work_id}})">{{detailData.work_code}}</c-link>
						<span v-else>{{detailData.work_code}}</span>
					</c-detail-item>
					<c-detail-item v-if="detailData.ref_code" label="关联单据">
						<order-link :type="detailData.ref_type" :id="detailData.ref_id" :code="detailData.ref_code"></order-link>
					</c-detail-item>
					<c-detail-item v-if="detailData.out_sourcing_orders" label="关联委外单">
						<order-link type="outSourcing" :data="detailData.out_sourcing_orders"></order-link>
					</c-detail-item>
					<custom-detail work-type="9" :data="detailData.customFieldValues"></custom-detail>
				</c-detail>
			</module-col>

			<module-col tab-type="border-tab">
				<module-tab name="报工记录" enable-flex>
					<div class="m-detail-box">
						<custom-table ref="outputTable" view-id="20005" height="grow" paging readonly>
							<!--计价方式-->
							<template #pricing_type="{data}">
								<c-state dict="pricingTypeDic" :value="data.pricing_type"></c-state>
							</template>
							
							<!--产品来源-->
							<template #product_source="{data}">
								<c-state dict="productSourceName" :value="data.product_source"></c-state>
							</template>
							
							<!--产品类型-->
							<template #product_type="{data}">
								<c-state dict="productTypeName" :value="data.product_type"></c-state>
							</template>
							
							<!--工单状态-->
							<template #work_state="{data}">
								<c-state dict="orderStateDic" tag :value="data.work_state"></c-state>
							</template>
							
							<!--任务状态-->
							<template #task_state="{data}">
								<c-state dict="orderStateDic" tag :value="data.task_state"></c-state>
							</template>
							
							<!--工资单价-->
							<template #price="{data}">
								￥{{parseFloat(parseFloat(data.price).toFixed(6))}}
							</template>
							
							<!--预计工资-->
							<template #pre_salary="{data}">
								￥{{parseFloat(data.pre_salary).toFixed(2)}}
							</template>
							
							<!--审批状态-->
							<template #state="{data}">
								<c-state dict="auditStateDic" tag :value="data.state"></c-state>
							</template>
							
							<!--报工良品率-->
							<template #fine_ratio="{data}">
								{{data.fine_ratio}}%
							</template>
							
							<!--检验方式-->
							<template #test_mode="{data}">
								<c-state dict="testModeDic" :value="data.test_mode"></c-state>
							</template>
							
							<!--检验状态-->
							<template #test_state="{data}">
								<c-state dict="testStateDic" :value="data.test_state"></c-state>
							</template>
							
							<!--质检人-->
							<template #test_user_realname="{data}">
								<span v-if="data.test_state == 3">{{data.test_user_realname}}</span>
								<span v-else>-</span>
							</template>
							
							<!--质检时间-->
							<template #test_date="{data}">
								<span v-if="data.test_state == 3">{{data.test_date}}</span>
								<span v-else>-</span>
							</template>
							
							<!--质检数-->
							<template #test_count="{data}">
								<span v-if="data.test_state == 3">{{data.test_count}}</span>
								<span v-else>-</span>
							</template>
							<!--质检数-合计行-->
							<template #test_count_summed="{total}">
								{{total}}
							</template>
							
							<!--质检合格数-->
							<template #test_fine_count="{data}">
								<span v-if="data.test_state == 3">{{data.test_fine_count}}</span>
								<span v-else>-</span>
							</template>
							<!--质检合格数-合计行-->
							<template #test_fine_count_summed="{total}">
								{{total}}
							</template>
							
							<!--质检不合格数-->
							<template #test_defects_count="{data}">
								<span v-if="data.test_state == 3">{{data.test_defects_count}}</span>
								<span v-else>-</span>
							</template>
							<!--质检不合格数-合计行-->
							<template #test_defects_count_summed="{total}">
								{{total}}
							</template>
							
							<!--质检良品率-->
							<template #test_fine_ratio="{data}">
								<span v-if="data.test_state == 3">{{data.test_fine_ratio}}%</span>
								<span v-else>-</span>
							</template>
						</custom-table>
					</div>
				</module-tab>
			</module-col>
		</module>
	</c-dialog>
</template>

<script>
	export default {
		name: 'taskDetail',

		props: {
			id: [String, Number]
		},
		
		data() {
			return {
				detailData: {}
			}
		},

		methods: {
			open() {
				this.request({
					url: '/task/detail',
					data: {
						id: this.id
					},
					loading: true,
					success: data => {
						this.detailData = data;
						this.$refs.outputTable.init();
						this.$refs.outputTable.$refs.list.load({
							url: '/output/list',
							data: {
								view_id: 20007,
								task_id: this.id
							}
						});
						this.$refs.dialog.open();
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>